import React from "react";
import AdminTestimonialManagement from "./AdminTestimonialManagement";

const AdminPage = () => {
      return ( 
            <>
                  <AdminTestimonialManagement/>
            </>
       );
}
 
export default AdminPage;